export default __webpack_public_path__ + "static/media/tecciance_logo.5dd3a80c.svg";